export default __webpack_public_path__ + "static/media/008-fair ship.e3c4ff6b.svg";